import {PATH} from "const/path";
import {useTeacherAction} from "../provider/_reducer";
import { GLOBAL_ICONS } from '../../../interface/icon'
import {TEACHER_GROUP_ICON} from "./icon";
import { useNavigate} from 'react-router-dom'
export const TEACHER_BREADCUM = [
    {id: 1, name: 'Home', url: PATH.SETTING},
    // {id: 2, name: 'Khách hàng', url: '#'},
    {id: 2, name: 'Quản lý giáo viên', url: '#'}
]
export const TEACHER_BUTTON_ACTION = (pageState, pageDispatch,t, action) => {
    const navigate = useNavigate()
    const TEACHER_ACTION_BUTTON = [
        {
            id: 1,
            name: null,
            appearance: 'secondary',
            icon: TEACHER_GROUP_ICON.repeat,
            onClick: () => action.refresh(),
        },
        {
            id: 2,
            name: 'Export excel',
            appearance: 'secondary',
            icon: GLOBAL_ICONS.export,
            onClick: () => action.export(),
        },
        {
            id: 3,
            name: 'Thêm giáo viên',
            appearance: 'primary',
            icon: GLOBAL_ICONS.plus,
            onClick: () => navigate(PATH.CREATE_TEACHER),
        },
    ]
    return {
        TEACHER_ACTION_BUTTON,
    }
}
export const TEACHER_STATUS=[
    {name: 'Đang hoạt động', value: 'active'},
    {name: 'Đang  khóa', value: 'inactive'},
]
export const TEACHER_TABLE_HEADER=[

]
export const INVENTORY_COLUMN_NAMES = {
        columnNames: [
            'STT',
            'Tên đăng nhập (*)',
            'Mật khẩu (*)',
            'Tên (*)',
            'Họ',
            'Trạng thái (*)',
            'Tên trường',
            'Số điện thoại',
            'Email',
            'Ngày sinh\n(dd/mm/yyyy)',
            'Giới tính',
            'Địa chỉ',
            'Số CMND/CCCD',
            'Số tài khoản',
            'Chủ tài khoản',
            'Ngân hàng'
        ],
        startRowNumber: 5,
};
export const TAG_DELETE=[
    'search',
    'status'
]
